import { createContext } from "react";
export const RadioContext = createContext({
    radioGroup: {
        value: "",
    },
});
